import { SelectField } from "@/lib/crm";

export const PAYMENT_TERMS = [
  { key: "rimessa_diretta", label: "Rimessa diretta a vista fattura" }, { key: "30_df", label: "30 giorni data fattura" },
  { key: "30_dffm", label: "30 giorni data fattura fine mese" }, { key: "60_df", label: "60 giorni data fattura" },
  { key: "60_dffm", label: "60 giorni data fattura fine mese" },
  { key: "30_60_df", label: "30/60 giorni data fattura" }, { key: "30_60_dffm", label: "30/60 giorni data fattura fine mese" },
  { key: "30_60_90_df", label: "30/60/90 giorni data fattura" }, { key: "30_60_90_dffm", label: "30/60/90 giorni data fattura fine mese" },
];
export const DEPOSITS = [20, 30, 40, 50].map((v) => ({ key: String(v), label: `${v}%` }));
export const paymentLabel = (k) => PAYMENT_TERMS.find((t) => t.key === k)?.label;

export const PaymentFields = ({ f, setF, testPrefix = "quote" }) => (
  <>
    <SelectField label="Condizioni di pagamento" value={f.payment_terms || ""} onChange={(v) => setF({ payment_terms: v || null })}
      options={PAYMENT_TERMS} allowNone="Non indicate" testId={`${testPrefix}-input-payment`} />
    <SelectField label="Acconto" value={f.deposit_pct ? String(f.deposit_pct) : ""} onChange={(v) => setF({ deposit_pct: v ? Number(v) : null })}
      options={DEPOSITS} allowNone="Nessun acconto" testId={`${testPrefix}-input-deposit`} />
  </>
);
